import { FC } from 'react';
import { Link } from 'react-router-dom';
import { IconShip, IconCalendar, IconClipboardList } from '@tabler/icons-react';

interface QuickAction {
  label: string;
  icon: React.ReactNode;
  linkTo: string;
  description?: string;
}

const QuickActions: FC = () => {
  const actions: QuickAction[] = [
    {
      label: 'View Bookings',
      icon: <IconClipboardList className="h-6 w-6" />,
      linkTo: '/partner/bookings',
      description: 'Manage all bookings',
    },
    {
      label: 'View Trips',
      icon: <IconCalendar className="h-6 w-6" />,
      linkTo: '/partner/trips',
      description: 'View trip schedule',
    },
    {
      label: 'Manage Boats',
      icon: <IconShip className="h-6 w-6" />,
      linkTo: '/partner/boats',
      description: 'View your boats',
    },
    // Settings disabled until route is implemented
    // {
    //   label: 'Settings',
    //   icon: <IconSettings className="h-6 w-6" />,
    //   linkTo: '/partner/settings',
    //   description: 'Account settings',
    // },
  ];

  return (
    <div className="rounded-lg bg-white p-6 shadow-sm">
      <h2 className="mb-4 text-xl font-semibold text-gray-900">
        Quick Actions
      </h2>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {actions.map(action => (
          <Link
            key={action.label}
            to={action.linkTo}
            className="group flex flex-col items-center rounded-lg border border-gray-200 p-4 text-center transition-all hover:border-blue-500 hover:bg-blue-50"
          >
            <div className="mb-2 text-blue-600 transition-colors group-hover:text-blue-700">
              {action.icon}
            </div>
            <div className="font-semibold text-gray-900 group-hover:text-blue-700">
              {action.label}
            </div>
            {action.description && (
              <div className="mt-1 text-xs text-gray-500">
                {action.description}
              </div>
            )}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;
